import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  width: 100%;
`;

const StyledSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #198754; /* Bootstrap success color */
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export default function Spinner() {
	return (
		<SpinnerContainer>
			<StyledSpinner />
		</SpinnerContainer>
	);
}
